import React, {useState} from 'react'
import { Col, Dropdown } from 'react-bootstrap'
import SearchField from '../../../universal/search-content-field/search-content-field.component'
import Table from './table'
import { changeSingleContactListModal, requestDeleteContactsArray } from '../../../../redux/actions/single-contact-list'
import EmptyTableView from '../../../universal/empty-table'
import { useSelector, useDispatch } from 'react-redux'
import { UpperRow } from '../../../library/upper-row'
import DropdownMenu from '../../../universal/dropdown-menu'
import { SolidButton } from '../../../library/button'
import { withRouter } from 'react-router-dom'
import './style.scss';

const Index = (props) => {

    const listId = props.match.params.id
    const dispatch = useDispatch()

	const [searchQuery, setSearchQuery] = useState("");

	const loading = useSelector(state => state.singleContactList.fetchRecords.loading)
	const records = useSelector(state => state.singleContactList.records)

  const [alternativeDropdownOpen, setAlternativeDropdownOpen] = useState(false)

	const searchList = e => {
        setSearchQuery(e.target.value);
	}

    const detailsLoading = useSelector(state => state.singleContactList.fetchDetails.loading)
    const name = useSelector(state => state.singleContactList.details.name)
    const deletions = useSelector(state => state.singleContactList.deletionArray)

    const deleteLoading = useSelector(state => state.singleContactList.deleteArray.loading)
    const activeCompany = useSelector(state => state.activeCompany && state.activeCompany.activeCompany)

    const renderToggle = () => {
      return(
        <Dropdown.Toggle onClick={() => setAlternativeDropdownOpen(!alternativeDropdownOpen)} disabled={false} id="dropdown-filter">
          <i class="fad fa-plus plus-icon"></i> Legg til kontakter <i class="fad arrow fa-angle-down"></i>
        </Dropdown.Toggle>
      )
    }
    
    const selectOptions = [
      {
        title: "Fra CSV-fil",
        key: "answerno",
        action: () => dispatch(changeSingleContactListModal({addCsvModal: true}))
      },
      {
        title: "separator",
        key: "separator",
      },
      {
        title: "Singel felt",
        key: "erase",
        active: null,
        action: () => dispatch(changeSingleContactListModal({addSingleModal: true}))
      }
    ]

    const renderListName = () => {
      if(detailsLoading){
        return " Laster inn"
      } else {
        return name ? name:"Ikke tilgjengelig"
      }
    }

    const determineDeleteButtonClick = () => {
        if(deletions && deletions.length > 0){
            clickDeleteContacts()
        }
    }

    const clickDeleteContacts = () => {
        dispatch(requestDeleteContactsArray({companyId: activeCompany.id, listId: listId, items: deletions}))
    }

    const renderMainButtons = () => {
        return [
            <SolidButton onClick={() => determineDeleteButtonClick()}  color="gray" spacing="right" icon={deleteLoading ? <i className="fas fa-circle-notch fa-spin"/>:<i className="fas fa-trash-alt"/>} title={deleteLoading ? "Sletter..":"Slett kontakter"}/>,
            <DropdownMenu size="regular" content="regular" type="title" color="inverse-blue" toggle={renderToggle()} title="Velg et alternativ" options={selectOptions} open={alternativeDropdownOpen} setOpen={setAlternativeDropdownOpen}/>
        ]
    }

	return(
		<Col md={8} className="dashboard-single-contact-list-left-container">
			<Col className="inner-dashboard-single-contact-list-left-container">
                <UpperRow title={`${renderListName()}`} buttons={renderMainButtons()}/>
				<SearchField searchQuery={searchQuery} handleSearch={searchList}/>
				<Table searchQuery={searchQuery}/>
				{!loading && records.length === 0 ? <EmptyTableView title="Ingen kontakter lagt til" description="Her var det veldig tomt, men slapp helt av! Du kan enkelt legge til en ny kontakt ved å trykke på knappen øverst til høyre."/>:null}
			</Col>
		</Col>
	)
}

export default withRouter(Index)